import heroMarkingLight from "../assets/images/hero-marking-light-pexels.jpeg";
import heroMarkingDark from "../assets/images/hero-marking-dark-pexels.jpeg";
import { useNavigate } from "react-router-dom";

export default function MarkingPage() {
  const navigate = useNavigate();
  return (
    <>
      <section className="relative mb-8 overflow-hidden rounded-2xl">
        {/* Background images per theme */}
        <img
          src={heroMarkingLight}
          alt="Teacher grading assignments with daylight"
          className="theme-light-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />

        <img
          src={heroMarkingDark}
          alt="Educator working through assignments at night"
          className="theme-dark-only absolute inset-0 h-56 w-full object-cover md:h-72"
        />
        <div
          className="absolute inset-0 bg-gradient-to-b from-white/60 via-white/40 to-white dark:from-gray-900/60 dark:via-gray-900/40 dark:to-gray-900"
        />
        <div className="relative z-10 p-6">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <h1 className="text-2xl font-semibold text-gray-900">Marking Queue</h1>
              <p className="mt-1 text-gray-700">
                Quickly view, prioritise and complete outstanding marking tasks.
              </p>
            </div>

            <a
              href="/app/assessments/new"
              className="inline-flex w-max items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-medium text-white shadow hover:bg-primary/90"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="h-4 w-4"
              >
                <path
                  fillRule="evenodd"
                  d="M12 4.5a.75.75 0 01.75.75v6h6a.75.75 0 010 1.5h-6v6a.75.75 0 01-1.5 0v-6h-6a.75.75 0 010-1.5h6v-6A.75.75 0 0112 4.5z"
                  clipRule="evenodd"
                />
              </svg>
              New assessment
            </a>
          </div>
          {/* Credits – light */}
          <p className="mt-2 text-xs text-gray-500 dark:hidden">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@rdne"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              RDNE Stock project
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>

          {/* Credits – dark */}
          <p className="mt-2 hidden text-xs text-gray-400 dark:block">
            Photo by{' '}
            <a
              href="https://www.pexels.com/@cottonbro"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              cottonbro studio
            </a>{' '}
            on{' '}
            <a
              href="https://www.pexels.com"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Pexels
            </a>
          </p>
        </div>
      </section>

      <div className="space-y-4">
        {/* Table wrapper */}
        <div className="overflow-x-auto rounded-lg border bg-white dark:bg-gray-800 dark:border-gray-700 shadow-sm">
        <table className="min-w-full divide-y divide-gray-100 dark:divide-gray-700 text-sm">
          <thead className="bg-gray-50 dark:bg-gray-700 text-left font-medium text-gray-600 dark:text-gray-300">
            <tr>
              <th className="px-4 py-3">Student</th>
              <th className="px-4 py-3">Assignment</th>
              <th className="px-4 py-3">Submitted</th>
              <th className="px-4 py-3">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {[
              { student: "Alice", assn: "Essay 1", date: "2025-06-01", status: "Pending" },
              { student: "Bob", assn: "Lab Report", date: "2025-06-02", status: "Pending" },
              { student: "Charlie", assn: "Quiz 4", date: "2025-05-30", status: "In review" },
            ].map((row, idx) => (
              <tr
                key={row.student + row.assn}
                className="hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
                onClick={() => navigate(`/app/marking/${idx + 1}`)}
              >
                <td className="px-4 py-3 whitespace-nowrap">{row.student}</td>
                <td className="px-4 py-3 whitespace-nowrap">{row.assn}</td>
                <td className="px-4 py-3 whitespace-nowrap">{row.date}</td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <span
                    className={
                      row.status === "Pending"
                        ? "rounded bg-yellow-100 dark:bg-yellow-900/20 px-2 py-0.5 text-xs font-medium text-yellow-800 dark:text-yellow-200"
                        : "rounded bg-blue-100 dark:bg-blue-900/20 px-2 py-0.5 text-xs font-medium text-blue-800 dark:text-blue-200"
                    }
                  >
                    {row.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </>
  );
}
